import {
    GET_NOTIFICATIONS,
    NOTIFICATIONS_ERROR,
    MARK_NOTIFICATIONS_READ,
    DISMISS_NOTIFICATION,
    LOGOUT,
} from '../actions/types';

const initialState = {
    notifications: [],
    unreadCount: 0,
    loading: true,
    error: {},
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_NOTIFICATIONS:
        case MARK_NOTIFICATIONS_READ:
        case DISMISS_NOTIFICATION:
            return {
                ...state,
                notifications: payload.notifications || [],
                unreadCount: payload.unreadCount || 0,
                loading: false,
            };
        case NOTIFICATIONS_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case LOGOUT:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
